import { Box, Button, Grid, Tooltip, Typography } from "@material-ui/core";
import { memo, useState } from "react";
import { useStyles } from "./card-roadmap-btn-votar-styles";
import classNames from "classnames";
import { ConfirmarIcon } from "views/components/icons/confirmar-icon";

interface CardRoadmapBtnVotarProps {
    porcentagem?: number;
    votado: boolean;
    disabled: boolean | undefined;
    handleVoteClick: (e: React.MouseEvent) => void
    votos: number
    isDiffRevenda: boolean
}

export const CardRoadmapBtnVotar = memo(({ votado, disabled, handleVoteClick, votos, isDiffRevenda }: CardRoadmapBtnVotarProps) => {
    const classes = useStyles()
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Grid item xs="auto">
            <Tooltip arrow title="Quantidade de votos" placement="top">
                <Box className={classes.qtdeVotos}>
                    <Typography color="primary" variant="h5" align="center">
                        {votos}
                    </Typography>
                </Box>
            </Tooltip>
            <Tooltip arrow title={disabled && !votado ? isDiffRevenda ? "Apenas Revenda pode votar" : "Votação fechada" : votado ? (isHovered ? "Desfazer voto" : "Votado") : 'Votar'}>
                <Button
                    className={classNames(classes.votacaoBtn, votado && classes.votadoBtn, disabled && !votado && classes.disabled)}
                    variant="outlined"
                    onClick={handleVoteClick}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <Box display="flex">
                        {votado ? (
                            isHovered ? "Desfazer" : <ConfirmarIcon tipo="BUTTON" />
                        ) : "Votar"}
                    </Box>
                </Button>
            </Tooltip>
        </Grid>
    )
})

CardRoadmapBtnVotar.displayName = "CardRoadmapBtnVotar"